import { Machine, interpret, assign } from 'xstate';

export const INITIAL_FALCON_STATE = 'idle';
const TIMER_MULTIPLIER = 1;
const FALCON_DELAYS = {
  FLIGHT_COMPUTER_CONTROL_START: 5000 * TIMER_MULTIPLIER,
  COUNTDOWN_T_MINUS_10: 5000 * TIMER_MULTIPLIER,
  COUNTDOWN_T_MINUS_5: 5000 * TIMER_MULTIPLIER,
  COUNTDOWN_T_MINUS_4: 1000 * TIMER_MULTIPLIER,
  COUNTDOWN_T_MINUS_3: 1000 * TIMER_MULTIPLIER,
  ENGINE_IGNITION: 1 * TIMER_MULTIPLIER,
  COUNTDOWN_T_MINUS_2: 1000 * TIMER_MULTIPLIER,
  COUNTDOWN_T_MINUS_1: 1000 * TIMER_MULTIPLIER,
  LIFTOFF: 1000 * TIMER_MULTIPLIER,
  PRE_MAX_Q: 10000 * TIMER_MULTIPLIER,
  MAX_Q_MOMENT: 5000 * TIMER_MULTIPLIER, // Original 1:12 Minute + 20000
  SUPERSONIC: 4000 * TIMER_MULTIPLIER,
  POST_SUPERSONIC: 5000 * TIMER_MULTIPLIER,
  PRE_MECO: 10000 * TIMER_MULTIPLIER,
  MECO: 5000 * TIMER_MULTIPLIER, // Original 2:17 Minute + 20000
  FIRST_STAGE_DROP_OFF: 5000 * TIMER_MULTIPLIER,
  STAGES_SEPARATE: 5000 * TIMER_MULTIPLIER, // Original 2:20 Minute + 20000
  SES: 5000 * TIMER_MULTIPLIER, // Original 2:27 Minute + 20000 - Secondary Engine Starts
  SECO: 10000 * TIMER_MULTIPLIER, // Original 10:08 Minute + 20000
  SECOND_STAGE_DROP_OFF: 5000 * TIMER_MULTIPLIER,
  GNOMES_DEPLOY: 5000 * TIMER_MULTIPLIER, // Original 10:08 Minute + 20000
  END: 5000 * TIMER_MULTIPLIER,
};

export const SPEECH_TEXTS = {
  precheck: 'Crew Dragon We are go for Launch!',
  computerControlStart: 'Launch Sequence Started, Falcon9 in startup',
  countDownTMinus10: 'T Minus 10 SECONDS',
  countDownTMinus5: 'T Minus 5 SECONDS',
  countDownTMinus4: '4 SECONDS',
  countDownTMinus3: '3',
  countDownTMinus2: '2',
  engineIgnition: 'Ignition',
  countDownTMinus1: '1',
  liftoff: 'LIFTOFF!!!! ',
  preMaxQ: 'M-1-D Throttle Down',
  maxQ: 'MaxQ!!  Vehicle is experiencing Maximum Dynamic Pressure',
  superSonic: 'Vehicle is Supersonic',
  postSuperSonic: 'M-1-D Throttle Up',
  preMeco: 'M-1-D Throttle Down',
  meco: 'meco!! Main Engine Cut Off',
  firstStageDropOff: 'Stage 1 Separation Confirmed',
  stagesSeparate: 'InterStage Separation Confirmed',
  ses: 'M Vac Engine Ignition',
  seco: 'seco!! Second Engine Cut Off',
  secondStageDropOff: 'Stage 2 Separation Confirmed',
  end: 'Crew Dragon on the way to the International Space Station',
};

const speechSynthesisEnabled = 'speechSynthesis' in window;

const synthesizeSpeech = text => {
  if (!speechSynthesisEnabled) {
    return;
  }

  const msg = new window.SpeechSynthesisUtterance();
  msg.voice = speechSynthesis.getVoices().filter(voice => voice.name == 'Alex')[0];
  msg.rate = 1.2;
  msg.text = text;

  window.speechSynthesis.speak(msg);
};

const takeAction = (context, event, meta) => {
  // console.log('ACTIONS: ', context, event, meta);
  console.log('STATE: ', meta.state.value, SPEECH_TEXTS[meta.state.value]);

  SPEECH_TEXTS[meta.state.value] && synthesizeSpeech(SPEECH_TEXTS[meta.state.value]);
};

const FalconStateChart = Machine(
  {
    id: 'falcon',
    initial: INITIAL_FALCON_STATE,
    context: {},
    states: {
      idle: {
        on: {
          INITIATE_LAUNCH_SEQUENCE: {
            target: 'precheck',

            actions: ['takeAction'],
          },
        },
      },
      precheck: {
        after: {
          FLIGHT_COMPUTER_CONTROL_START: {
            target: 'computerControlStart',
            actions: ['takeAction'],
          },
        },
      },
      computerControlStart: {
        after: {
          COUNTDOWN_T_MINUS_10: {
            target: 'countDownTMinus10',
            actions: ['takeAction'],
          },
        },
      },
      countDownTMinus10: {
        after: {
          COUNTDOWN_T_MINUS_5: {
            target: 'countDownTMinus5',
            actions: ['takeAction'],
          },
        },
      },
      countDownTMinus5: {
        after: {
          COUNTDOWN_T_MINUS_4: {
            target: 'countDownTMinus4',
            actions: ['takeAction'],
          },
        },
      },
      countDownTMinus4: {
        after: {
          COUNTDOWN_T_MINUS_3: {
            target: 'countDownTMinus3',
            actions: ['takeAction'],
          },
        },
      },
      countDownTMinus3: {
        after: {
          COUNTDOWN_T_MINUS_2: {
            target: 'countDownTMinus2',
            actions: ['takeAction'],
          },
        },
      },
      countDownTMinus2: {
        after: {
          ENGINE_IGNITION: {
            target: 'engineIgnition',
            actions: ['takeAction'],
          },
        },
      },
      engineIgnition: {
        after: {
          COUNTDOWN_T_MINUS_1: {
            target: 'countDownTMinus1',
            actions: ['takeAction'],
          },
        },
      },
      countDownTMinus1: {
        after: {
          LIFTOFF: {
            target: 'liftoff',
            actions: ['takeAction'],
          },
        },
      },
      liftoff: {
        after: {
          PRE_MAX_Q: {
            target: 'preMaxQ',
            actions: ['takeAction'],
          },
        },
      },
      preMaxQ: {
        after: {
          MAX_Q_MOMENT: {
            target: 'maxQ',
            actions: ['takeAction'],
          },
        },
      },
      maxQ: {
        after: {
          SUPERSONIC: {
            target: 'superSonic',
            actions: ['takeAction'],
          },
        },
      },
      superSonic: {
        after: {
          POST_SUPERSONIC: {
            target: 'postSuperSonic',
            actions: ['takeAction'],
          },
        },
      },
      postSuperSonic: {
        after: {
          PRE_MECO: {
            target: 'preMeco',
            actions: ['takeAction'],
          },
        },
      },
      preMeco: {
        after: {
          MECO: {
            target: 'meco',
            actions: ['takeAction'],
          },
        },
      },
      meco: {
        after: {
          FIRST_STAGE_DROP_OFF: {
            target: 'firstStageDropOff',
            actions: ['takeAction'],
          },
        },
      },
      firstStageDropOff: {
        after: {
          STAGES_SEPARATE: {
            target: 'stagesSeparate',
            actions: ['takeAction'],
          },
        },
      },
      stagesSeparate: {
        after: {
          SES: {
            target: 'ses',
            actions: ['takeAction'],
          },
        },
      },
      ses: {
        after: {
          SECO: {
            target: 'seco',
            actions: ['takeAction'],
          },
        },
      },
      seco: {
        after: {
          SECOND_STAGE_DROP_OFF: {
            target: 'secondStageDropOff',
            actions: ['takeAction'],
          },
        },
      },
      secondStageDropOff: {
        after: {
          GNOMES_DEPLOY: {
            target: 'gnomesDeploy',
            actions: ['takeAction'],
          },
        },
      },
      gnomesDeploy: {
        after: {
          END: {
            target: 'end',
            actions: ['takeAction'],
          },
        },
      },
      end: {
        type: 'final',
      },
    },
  },
  {
    delays: FALCON_DELAYS,
    actions: { takeAction },
  },
);

export const makeFalconStateChart = eventHandler => {
  const extended = FalconStateChart.withConfig({
    actions: {},
  });
  const stateChart = interpret(extended);
  return stateChart;
};
